import { NgModule } from '@angular/core';
import { OhayoUtilModule } from '@ohayojp/util';

@NgModule({
  imports: [OhayoUtilModule],
})
export class LodopModule { }
